import React, { useEffect, useMemo, useState } from 'react'
import { Box, Button, Modal, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { Item } from '../../Common/Item/item'
import { FaArrowLeft } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { CreateClass } from '../../Common/CreateClass/createClass'
import { educatorClassesSx, MainBox } from '../styles'
import { Loader } from '../../Common/Loader/loader'
import { ShowErrorToast, ShowSuccessToast } from '../../Common/Toast/toast'
import ERROR_CONSTANTS from '../../../Infrastructure/Constants/errorConstants'
import { FaCopy } from "react-icons/fa";
import useServerClock from '../../../Infrastructure/CustomHooks/useServerClock'

export const Classes = () => {
  const serverNow = useServerClock()
  const [tab, setTab] = useState(null);
  const [newClass, setNewClass] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedLearners, setSelectedLearners] = useState([]);
  const [showLearnersModal, setShowLearnersModal] = useState(false);
  const [showNewCourseForm, setShowNewCourseForm] = useState(false);
  const [inProgressClasses, setInProgressClasses] = useState([]);
  const [enrolledPendingClasses, setEnrolledPendingClasses] = useState([]);
  const [enrolledInactiveClasses, setEnrolledInactiveClasses] = useState([]);
  const [enrolledActiveClasses, setEnrolledActiveClasses] = useState([]);
  const [enrolledUpComingClasses, setEnrolledUpComingClasses] = useState([]);
  const [enrolledClassesLoading, setEnrolledClassesLoading] = useState(false);
    
  const handleSeeLearners = (learners) => {
    setSelectedLearners(learners || []);
    setShowLearnersModal(true);
  };

  const handleCloseLearnersModal = () => {
    setShowLearnersModal(false);
    setSelectedLearners([]);
  };

  const handleCopyEmails = () => {
  (async () => {
    try {
      const emails = (selectedLearners || [])
        .map((l) => {
          if (!l) return '';
          if (typeof l === 'string') return l.trim();
          if (typeof l === 'object') {
            return (
              l?.account?.email?.trim?.() ||
              ''
            );
          }
          return '';
        })
        .filter(Boolean);
      if (emails.length === 0) {
        ShowErrorToast('No emails to copy.');
        return;
      }
      const text = emails.join(', ');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        ShowSuccessToast('Copied emails to clipboard');
      } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (!ok) throw new Error('copy-failed');
        ShowSuccessToast('Copied emails to clipboard');
      }
    } catch (err) {
      ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST);
    }
  })();
  };
  const handleCreateNewCourse = () => {
    setSelectedClass(null)
    setShowNewCourseForm(true);
    setNewClass(true)
  }

  const handleCloseForm = () => {
    setShowNewCourseForm(false);
  }
  const handleClick = (course, courseId, classId, courseClass) => {
    setSelectedClass({ course, courseId, classId, courseClass })
    setShowNewCourseForm(true);
  }
  const getClassCount = (classes) => classes.length;
  const userData = useSelector((state) => state.userData.data);
  const coursesArray = useMemo(() => {
    const courses = userData?.educator?.courses;
    return courses ? Object.entries(courses) : [];
  }, [userData?.educator?.courses]);
  const activeCourses = coursesArray.filter(([_, details]) => details?.status === 'active')
  const fetchClasses = async () => {
    try {
      if (!coursesArray || !Array.isArray(coursesArray)) return;
      const pending = [], active = [], upcoming = [], inactive = [], in_progress = [];
      coursesArray.forEach(([courseId, courseData]) => {
        const schedule = courseData?.courseDetails?.class_schedule;
        if (schedule && typeof schedule === "object") {
          Object.entries(schedule).forEach(([classId, classData]) => {
            if (
              classData &&
              typeof classData === "object" &&
              classData.first_class &&
              classData.last_class
            ) {
              const enriched = {
                courseClass: classData,
                classId,
                courseId,
                course:courseData,
                courseTitle: courseData?.courseDetails?.basics?.title,
              };
              const { first_class, last_class, status } = classData;
              if (status === "active" && serverNow >= first_class && serverNow <= last_class) {
                active.push(enriched);
              } else if (
                status === "pending" &&
                first_class > serverNow &&
                first_class - serverNow <= 86400000
              ) {
                pending.push(enriched);
              } else if (status === "active" && first_class > serverNow) {
                upcoming.push(enriched);
              } else if (status === "in_progress") {
                in_progress.push(enriched);
              } else {
                inactive.push(enriched);
              }
            }
          })
        }
      })
      setEnrolledActiveClasses(active);
      setEnrolledPendingClasses(pending);
      setEnrolledUpComingClasses(upcoming);
      setEnrolledInactiveClasses(inactive);
      setInProgressClasses(in_progress);
    } catch (error) {
      ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
    } finally {
      setEnrolledClassesLoading(false);
    }
  };
  useEffect(() => {
    const tabCounts = {
      active: enrolledActiveClasses.length,
      upcoming: enrolledUpComingClasses.length,
      pending: enrolledPendingClasses.length,
      in_progress: inProgressClasses.length,
      inactive: enrolledInactiveClasses.length,
    }
    // If current tab still has items, respect user choice
    if (tabCounts[tab] > 0) return;
    // Otherwise, switch to first available tab
    const firstAvailable = Object.entries(tabCounts)
      .find(([_, count]) => count > 0);
    if (firstAvailable) {
      setTab(firstAvailable[0]);
    }
  }, [
    enrolledActiveClasses,
    enrolledUpComingClasses,
    enrolledPendingClasses,
    inProgressClasses,
    enrolledInactiveClasses,
    tab,
  ]);
  useEffect(() => {
    if (!serverNow || !userData) return;    
    setEnrolledClassesLoading(true)
    fetchClasses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [JSON.stringify(userData?.educator?.courses), serverNow]);
  return (
    <MainBox sx={educatorClassesSx.mainBox}>
      <Modal open={showLearnersModal} onClose={handleCloseLearnersModal}>
        <Box sx={educatorClassesSx.modalBox}>
          <Box sx={educatorClassesSx.modalHeader}>
            <Typography variant="subtitle1" sx={educatorClassesSx.modalTitle}>
              Learners
            </Typography>
            <Button
              size="small"
              variant="contained"
              color="primary"
              startIcon={<FaCopy />}
              onClick={handleCopyEmails}
              sx={educatorClassesSx.copyButton}
            >
              Copy All Emails
            </Button>
          </Box>
          <Table
            size="small"
            sx={educatorClassesSx.table}
          >
            <TableHead>
              <TableRow sx={educatorClassesSx.tableHeaderRow}>
                <TableCell
                  sx={educatorClassesSx.tableHeaderCell}
                >
                  Name
                </TableCell>
                <TableCell sx={educatorClassesSx.tableHeaderCell}>
                  Email
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedLearners.length > 0 ? (
                selectedLearners.map((learner, idx) => (
                  <TableRow
                    key={idx}
                    sx={educatorClassesSx.tableRow}
                  >
                    <TableCell sx={educatorClassesSx.tableCell}>
                      {learner?.account?.first_name} {learner?.account?.last_name}
                    </TableCell>
                    <TableCell sx={educatorClassesSx.tableCell}>
                      {learner?.account?.email}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center" sx={educatorClassesSx.emptyTableCell}>
                    No learners found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Modal>
      {showNewCourseForm ? (
        <Box sx={educatorClassesSx.backIconWrapper}>
          <FaArrowLeft onClick={handleCloseForm} />
        </Box>
      ) : (
        <Box sx={educatorClassesSx.pageHeader}>
          <Typography sx={educatorClassesSx.classesTitle} variant='h1'>Classes</Typography>
          {activeCourses.length > 0 && (
            <Button variant="contained" color="primary" onClick={handleCreateNewCourse}>
              Create New Class
            </Button>
          )}
        </Box>
      )}
      {showNewCourseForm ? (
        <CreateClass coursesArray={coursesArray} isDashboard={true} selectedClass={selectedClass} newClass={newClass} setNewClass={setNewClass} setShowNewCourseForm={setShowNewCourseForm} />
      ) : (
        <Box>
          {enrolledClassesLoading ? (
              <Loader height={'80vh'}/>
          ): coursesArray.length > 0 ? (
              <Box width="100%">
              <Box sx={educatorClassesSx.tabsWrapper}>
                {['active', 'upcoming', 'pending', 'in_progress', 'inactive'].map((type) => {
                    const count = type === 'active'
                      ? getClassCount(enrolledActiveClasses)
                      : type === 'upcoming'
                        ? getClassCount(enrolledUpComingClasses)
                      : type === 'pending'
                        ? getClassCount(enrolledPendingClasses)
                        : type === 'in_progress'
                          ? getClassCount(inProgressClasses)
                        : getClassCount(enrolledInactiveClasses);
                    if (count === 0) return null
                    return (
                      <Box key={type} sx={educatorClassesSx.tabItemWrapper}>
                        <Typography
                          color={tab === type ? 'primary' : 'inherit'}
                          sx={{
                              ...educatorClassesSx.tabText,
                              ...(tab === type ? educatorClassesSx.tabActive : educatorClassesSx.tabInactive)
                          }}
                          onClick={() => setTab(type)}
                        >
                          {type === "in_progress" ? "IN PROGRESS" : type.toUpperCase()}
                        </Typography>

                        {count > 0 && (
                          <Box sx={educatorClassesSx.tabCountBadge}>
                            <Typography variant="caption" sx={educatorClassesSx.tabCountText}>
                              {count}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
                <Box sx={educatorClassesSx.classesScrollWrapper}>
              {['active', 'upcoming', 'pending', 'inactive', 'in_progress'].map(type => {
                const dataMap = {
                  active: enrolledActiveClasses,
                  upcoming: enrolledUpComingClasses,
                  pending: enrolledPendingClasses,
                  inactive: enrolledInactiveClasses,
                  in_progress: inProgressClasses
                };
                const dataList = dataMap[type];

                return tab === type && (
                  <Box key={type} sx={educatorClassesSx.classItemsWrapper}>
                      {dataList.length > 0 ? (
                        dataList.map((classData) => {
                          const { courseTitle, courseId, classId, courseClass, course } = classData;
                          return (
                            <Item
                              key={`${courseId}${classId}`}
                              courseTitle={courseTitle}
                              classItem={true}
                              classDetails={{ ...courseClass, classId }}
                              status={courseClass.status}
                              isClassReadyToHost={
                                courseClass.status === "active" &&
                                serverNow >= courseClass.first_class &&
                                serverNow <= courseClass.last_class
                              }
                              onClick={() => handleClick(course, courseId, classId, courseClass)}
                              onSeeLearners={handleSeeLearners}
                            />
                          );
                        })
                      ) : (
                        <Typography>No {type} classes</Typography>
                      )}
                    </Box>
                  )})}
                </Box>
              </Box>
            ) : (
            <Box sx={educatorClassesSx.emptyStateWrapper}>
              <Typography sx={educatorClassesSx.emptyStateText}>
                {coursesArray.length > 0
                  ? "No classes have been created yet."
                  : "Classes will appear here once a course has been successfully created"
                }
              </Typography>
            </Box>
          )
          }
        </Box>
      )}
    </MainBox>

  )
}
